<script setup>
import { RadioGroupItem, RadioGroupIndicator } from "reka-ui";
import { CircleIcon } from "lucide-vue-next";
import { cn } from "@/shared/lib/utils";

const props = defineProps({
  value: { type: [String, Number, Boolean], default: undefined },
  label: { type: [String, Number, Boolean, Object], default: undefined },
  disabled: { type: Boolean, default: false },
  class: { type: [String, Object, Array], default: undefined },
});

// Support both :value and :label (el-radio compat)
const itemValue = String(props.value ?? props.label ?? "");
</script>

<template>
  <label
    :class="
      cn(
        'flex items-center gap-2 cursor-pointer text-sm font-medium text-foreground',
        disabled && 'cursor-not-allowed opacity-50',
        props.class
      )
    "
  >
    <RadioGroupItem
      :value="itemValue"
      :disabled="disabled"
      :class="
        cn(
          'border-input text-foreground focus-visible:border-foreground focus-visible:ring-foreground/50 aspect-square size-4 shrink-0 rounded-full border transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50'
        )
      "
    >
      <RadioGroupIndicator class="relative flex items-center justify-center">
        <CircleIcon
          class="fill-foreground absolute top-1/2 left-1/2 size-2 -translate-x-1/2 -translate-y-1/2"
        />
      </RadioGroupIndicator>
    </RadioGroupItem>
    <span><slot /></span>
  </label>
</template>
